import React, { Component } from "react";
import relationshipbanner from "views/job-details/img/relationship-img.png";
import defaultImage from "../../../assets/img/defaultjob.png";
import banner from "../../../assets/img/bnrS.png";
import bookmark from "views/job-details/img/bookmark.png";
import share from "views/job-details/img/sharing.png";
import ApplicNavbar from "components/Navbars/ApplicantNavbar.js";
import ReferFriendPopup from "./ReferFriendPopup";
import JobDetailsApplyPopup from "./JobDetailsApplyPopup";
import { connect } from "react-redux";
import { AddBookmarkACTION } from "store/Bookmark";
import LoginPopup from "components/Navbars/components/LoginPopup";
// import RelationshipBanner from "views/know-us-more/components/RelationshipBanner";
class RelationshipBanner extends Component {
  constructor(props) {
    super(props);
    this.handler = this.handler.bind(this);
    this.state = {
      isrefermodalopen: false,
      isapplymodalopen: false,
      jobdetails: 0,
      isvideo: false,
      playing: false,
    };
    this.onclose = this.onclose.bind(this);
  }
  async onBookMark(ev, id) {
    // ev.target.src =
    let payload = {
      user_id: this.props.Auth.MGID,
      job_id: id,
    };
    let response = await this.props.AddBookmark(payload);
    // if(response.ResponseCode == 100){
    //   // ev.target.src = defaultjob;
    // }
  }
  addDefaultSrc(ev) {
    ev.target.src = defaultImage;
    // className = "bg-red w-full";
  }

  onclose() {
    this.setState({ isrefermodalopen: false });
  }
  handler() {
    this.setState({
      isapplymodalopen: false,
    });
  }

  footerApply() {
    this.setState({ isapplymodalopen: true, jobdetails: 1 });
  }

  async componentDidMount() {
    // let id = this.props.id
    // console.log(id);
    // let HcToken = await Token.getToken();
    // store.dispatch(setHcToken(HcToken));
    // let MgToken = await Token.getTokenMagitt();
    // store.dispatch(setMgToken(MgToken));
    // let response = await this.props.getdetailsaction(id);
    // // console.log(response.Data[0])
    // this.setState({ jobdetails: response.Data[0] });
    // if (this.state.jobdetails.f_mediaType !== "image") {
    //   this.setState({ isvideo: false });
    // }
    // console.log(this.state.jobdetails);
  }
  render() {
    const { jobdetails } = this.state;
    return (
      <div className="">
        {/* <ApplicNavbar /> */}
        <ReferFriendPopup
          showRefer={this.state.isrefermodalopen}
          onclose={this.onclose}
          jobdetails={jobdetails}
        />
        <JobDetailsApplyPopup
          showApply={this.state.isapplymodalopen}
          jobdetails={jobdetails}
          handler={this.handler}
        />
        <div className="relative md:px-0 lg:px-0 px-4">
          <div className="">
            {" "}
            <img
              onError={this.addDefaultSrc}
              // src={
              //   process.env.REACT_APP_IMAGE_BASE_MG + "" + this.props.previewjob
              //     ? this.props.previewjob.Data
              //       ? this.props.previewjob.Data.length > 0
              //         ? process.env.REACT_APP_IMAGE_BASE_MG +
              //           "" +
              //           this.props.previewjob.Data[0].f_path
              //         : ""
              //       : ""
              //     : ""
              // }
              src={banner}
              alt="relationshipbanner"
              // className="w-full maxh-420px sm-h-150px object-cover " //Push check
              className="w-full"
            />
          </div>

          <div className="inside-text-rel ">
            {/* <div className="w-3/4">
              <h1 className="font-bold fsize36 sm-fsize16 text-white">
                {this.props.previewjob
                  ? this.props.previewjob.Data.length > 0
                    ? this.props.previewjob.Data[0].f_title
                    : ""
                  : ""}
              </h1>
              <h1 className="font-normal sm-fsize12 fsize18 text-black lg:py-6 md:py-6 py-3 ">
                {this.props.previewjob
                  ? this.props.previewjob.Data.length > 0
                    ? this.props.previewjob.Data[0].f_short_description
                    : ""
                  : ""}
              </h1>
            </div> */}

            {/* <div className="lg:flex lg:mt-2 lg:mt-4 md:mt-4 sm-fixed-apply-btn sm-justify-center">
              <button
                className="cust-filled-btn-blue flex mr-4  sm-w155px  sm-fsize15"
                onClick={() =>
                  this.props.isAlreadyApplied
                    ? ""
                    : this.setState({ isapplymodalopen: true, jobdetails: 1 })
                }
              >
                {this.props.isAlreadyApplied ? "Applied" : "APPLY NOW"}
              </button>
            </div> */}
          </div>

          {/* <div className="inside-sharemark flex">
            <div className="bg-bluecolor w-h-50px  rounded-full grid justify-center items-center lg:mr-4 md:mr-4 mr-2">
              <img
                onClick={(e) => {
                  this.onBookMark(e, this.props.previewjob.Data[0].f_jobId);
                }}
                src={bookmark}
                className="mob-w10"
              />
            </div>
            <div className="bg-bluecolor w-h-50px  rounded-full grid justify-center items-center">
              <img src={share} className="mob-w10" />
            </div>
          </div> */}
        </div>
        {/* <card className="w-full  flex rounded-12px mt-6 mb-12  md:px-0 lg:px-0 px-4">
          <div className="lg:flex md:flex lg:items-center justify-around md:items-center w-full lg:p-10 md:p-10 p-4">
         <div className="lg:w-3/12 md:w-3/12 sm-flex-between-center w-full border2px-f5f5f5-r lg:pb-0 md:pb-0 pb-1	">
              <p className="text707070 fsize15 sm-fsize14">Category</p>
              <h1 className="fsize22 text262626 font-bold mt-1 sm-fsize14">
                {this.props.previewjob && this.props.previewjob.Data.length > 0
                  ? this.props.previewjob.Data[0].Department
                    ? this.props.previewjob.Data[0].Department
                    : "NA"
                  : "NA"}
              </h1>
            </div> 

            <div className="lg:w-9/12 md:w-9/12	w-full">
              <div className="lg:flex md:flex items-center">
                <div className="lg:w-1/4 md:1/4 w-full border2px-f5f5f5-r lg:flex md:flex  lg:justify-center md:justify-center   lg:pb-0 md:pb-0 pb-1">
                  <div className="sm-flex-between-center">
                    <p className="text707070 fsize15 sm-fsize14">Job Type</p>
                    <h1 className="fsize22 text262626 font-bold mt-1 sm-fsize14">
                      {this.props.previewjob &&
                      this.props.previewjob.Data.length > 0
                        ? this.props.previewjob.Data[0].JobType
                        : "NA"}
                    </h1>
                  </div>
                </div> 

                 <div className="lg:w-1/2 md:1/4 w-full border2px-f5f5f5-r lg:flex md:flex  lg:justify-center md:justify-center   lg:pb-0 md:pb-0 pb-1">
                  <div className="sm-flex-between-center">
                    <p className="text707070 fsize15 sm-fsize14">
                      Experience ( In Years )
                    </p>
                    <h1 className="fsize22 text262626 text-center font-bold mt-1 sm-fsize14">
                      {this.props.previewjob &&
                      this.props.previewjob.Data.length > 0
                        ? this.props.previewjob.Data[0].Experience
                        : "NA"}
                    </h1>
                  </div>
                </div> 

                 <div className="lg:w-1/4 md:1/4 w-full border2px-f5f5f5-r lg:flex md:flex  lg:justify-center md:justify-center   lg:pb-0 md:pb-0 pb-1">
                  <div className="sm-flex-between-center">
                    <p className="text707070 fsize15 sm-fsize14">Level</p>
                    <h1 className="fsize22 text262626 font-bold mt-1 sm-fsize14">
                      {this.props.previewjob &&
                      this.props.previewjob.Data.length > 0
                        ? this.props.previewjob.Data[0].Grade
                          ? this.props.previewjob.Data[0].Grade
                          : "NA"
                        : "NA"}
                    </h1>
                  </div>
                </div> 

                <div className="lg:w-1/2 md:1/4 w-full  lg:flex md:flex  lg:justify-center md:justify-center   lg:pb-0 md:pb-0 pb-1">
                  <div className="sm-flex-between-center">
                    <p className="text707070 fsize15 sm-fsize14 text-center">
                      Location
                    </p>
                    <h1 className="fsize22 text262626 font-bold mt-1 text-center sm-fsize14">
                      {this.props.previewjob &&
                      this.props.previewjob.Data.length > 0
                        ? this.props.previewjob.Data[0].Location
                          ? this.props.previewjob.Data[0].Location
                          : "NA"
                        : "NA"}
                    </h1>
                  </div>
                </div> 
              </div>
            </div>
          </div>
        </card> */}
      </div>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    Auth: state.Auth.user,
    previewjob: state.SingleJob.home.CURRENTJOB,
  };
};
// export default RelationshipBanner;
const mapDispatchToProps = (dispatch) => {
  return {
    AddBookmark: async (payload) => await dispatch(AddBookmarkACTION(payload)),
  };
};
export default connect(mapStateToProps, mapDispatchToProps, null, {
  forwardRef: true,
})(RelationshipBanner);
